/**
 * Mobile product accordions – position above the bundle widget.
 *
 * Liquid renders `.product__accordions.mobile-only` directly after the product
 * form, which is as close to the Add-to-cart button as markup alone can get.
 * The Max Bundle app then injects `.bundle-offer-container` *into* the form
 * after the submit holder, pushing the accordions ~480px further down.
 *
 * The app owns its insertion point, so the order can only be corrected after
 * the fact: once the widget exists, move the accordions in front of it.
 *
 * No breakpoint check on purpose. Above 768px `.mobile-only` is display:none
 * and the separate `.desktop-only` block is what renders, so the moved node's
 * position is irrelevant there — moving unconditionally keeps this simple and
 * means a desktop→mobile resize needs no extra handling.
 *
 * The move lands the accordions inside <form>, which is why their triggers
 * carry type="button" in product.liquid — without it they would default to
 * type="submit" and fire add-to-cart on every toggle.
 */

const ACCORDIONS_SELECTOR = '.product__accordions.mobile-only';
const BUNDLE_SELECTOR = '.bundle-offer-container';

// The widget is injected asynchronously; give up rather than observe forever.
const OBSERVE_TIMEOUT = 15000;

function moveAboveBundle(accordions) {
    const bundle = document.querySelector(BUNDLE_SELECTOR);
    if (!bundle) return false;
    if (accordions.nextElementSibling !== bundle) {
        bundle.parentNode.insertBefore(accordions, bundle);
    }
    return true;
}

function init() {
    const accordions = document.querySelector(ACCORDIONS_SELECTOR);
    if (!accordions) return;

    // Widget may already be there on a warm cache.
    if (moveAboveBundle(accordions)) return;

    const observer = new MutationObserver(() => {
        if (moveAboveBundle(accordions)) {
            observer.disconnect();
            window.clearTimeout(timeoutId);
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    const timeoutId = window.setTimeout(() => observer.disconnect(), OBSERVE_TIMEOUT);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
